module.exports = __webpack_public_path__ + "projects-hero.png";